export default (dataToTracking) => {
  return {
    event: 'promotionClick',
    route: dataToTracking.route,
    pnr: dataToTracking.pnr,
    ecommerce: {
      promoClick: {
        promotions: [{
          name: 'Protection Flight',
          id: 'Search a New Flight',
          creative: 'Reserve change',
          position: 'MYB',
        }],
      },
    },
  };
};